import './styles/BookPic.scss';

import { useEffect, useState } from "react";

function BookPic(props) {
    const {
        src,
        staticName,
        name
    } = props;

    const [hide, setHide] = useState('');

    useEffect(()=>{
        if (staticName != name) {
            setHide(' invisible');
        }
        else {
            setHide('');
        }
    },[props.name]);

    return (
        <div className={"slide " + name + hide}>
            <div id="barAnimation" className="slideLine"></div>
            <img src={src} alt="" />
            <p>{props.children}</p>
        </div>  
    )
}
            
export default BookPic;